import * as React from 'react';
import { FC } from 'react';
import app from 'src/js/App';
import { useSelector } from 'react-redux';
import { State } from 'moduleBase/types/State';
import { InitResponse } from 'moduleBase/actions/types/InitResponseType';
import { REDUCER_GLOBAL_NAME } from 'moduleBase/constants';

const LangsMenuToggler: FC = () => {
  const languageSettings = useSelector<State, InitResponse['languageSettings']>(
    (state) => state[REDUCER_GLOBAL_NAME].languageSettings,
  );

  return (
    <>
      <i className="dropdown-flat-list__icon coll-icon coll-icon-globe" />
      {app.tForReact('catalog_channel_list', 'Language')}
      <span className="dropdown-flat-list__item__language color-858585">
        {languageSettings.currentAsObject.name}
        <i className="fal fa-angle-right" />
      </span>
    </>
  );
};

export { LangsMenuToggler };
